module.exports = __webpack_public_path__ + "img/Pasticciera-NM-015.e459d2c0.jpg";